var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import usePermissions from "@/shared/presentation/context-api/hooks/get-user-permissions";
import React, { useCallback, useMemo } from "react";
import featureToggleConfig from "../../feature-toggle-config";
var initialState = {
    loading: true,
    isFeatureEnabled: function (feature) { return true; },
};
export var FeatureToggleContext = React.createContext(initialState);
var permissionedFeatures = featureToggleConfig;
var getEnabledFeatures = function (hasPermission) {
    return Object.keys(permissionedFeatures).reduce(function (previousValue, permission) {
        if (!hasPermission(permission))
            return previousValue;
        return __spreadArray(__spreadArray([], previousValue), permissionedFeatures[permission]);
    }, []);
};
export var FeatureToggleProvider = function (_a) {
    var children = _a.children;
    var _b = usePermissions(), hasPermission = _b.hasPermission, loadingPermissions = _b.loadingPermissions;
    var enabledFeatures = useMemo(function () { return getEnabledFeatures(hasPermission); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loadingPermissions, hasPermission]);
    var isFeatureEnabled = useCallback(function (feature) { return enabledFeatures.includes(feature); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loadingPermissions]);
    return (React.createElement(FeatureToggleContext.Provider, { value: { isFeatureEnabled: isFeatureEnabled, loading: loadingPermissions } }, children));
};
